import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IDocumentConstructorState } from "@/store/modules/documentConstructor/state";
import { IRootState } from "@/store";
import { DocumentConstructor } from "@/types";
import { DocumentConstructorMutations } from "@/store/modules/documentConstructor/mutations";
import { JobMutations } from "@/store/modules/job/mutations";
import { DocumentActions } from "@/store/modules/document/actions";
import { DocumentMutations } from "@/store/modules/document/mutations";

export enum DocumentConstructorActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_DOCUMENT_CONSTRUCTOR",
  FETCH_ONE = "FETCH_ONE_DOCUMENT_CONSTRUCTOR",
  FETCH_ALL = "FETCH_ALL_DOCUMENT_CONSTRUCTOR",
  CREATE = "CREATE_DOCUMENT_CONSTRUCTOR",
  UPDATE = "UPDATE_DOCUMENT_CONSTRUCTOR",
  DELETE = "DELETE_DOCUMENT_CONSTRUCTOR",
}

export const actions: ActionTree<IDocumentConstructorState, IRootState> = {
  async [DocumentConstructorActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/documents/document-constructor/list", {
        params: params,
      });
      commit(DocumentConstructorMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch documentConstructor data provider error: ", error);
    }
  },
  async [DocumentConstructorActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(
        `/documents/document-constructor/view/${id}`
      );
      commit(DocumentConstructorMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch documentConstructor data provider error: ", error);
    }
  },
  async [DocumentConstructorActions.FETCH_ALL]({ commit }) {
    try {
      const result = await baseApi.get(
        "/documents/document/sub-data/constructors"
      );
      commit(DocumentConstructorMutations.SET_ALL, result.data.data.items);
    } catch (error) {
      console.log("fetch document constructor all error: ", error);
    }
  },
  async [DocumentConstructorActions.CREATE](
    { commit },
    data: DocumentConstructor
  ) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/documents/document-constructor/create", data)
        .then((data) => {
          commit(DocumentMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("document constructor create error: ", error);
          reject(error.response);
        });
    });
  },
  async [DocumentConstructorActions.UPDATE]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(
          `/documents/document-constructor/update/${payload.id}`,
          payload.data
        )
        .then((data) => {
          commit(JobMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("documentConstructor update error: ", error);
          reject(error.response);
        });
    });
  },
  async [DocumentConstructorActions.DELETE](
    { commit },
    payload: string | { id: string; coordinatorId?: string }
  ) {
    const id = typeof payload === "string" ? payload : payload.id;
    const coordinatorId =
      typeof payload === "object" ? payload.coordinatorId : undefined;
    try {
      await baseApi.delete(`/documents/document-constructor/delete/${id}`, {
        params: coordinatorId != null ? { coordinatorId } : undefined,
      });
    } catch (error) {
      console.log("documentConstructor delete error:", error);
      throw error;
    }
  },
};
